var BaseCollection = require('./base-collection');


var FaceToFaceFormCollection = BaseCollection.extend({
    url:"/api/face-to-face-form",
    sortConf: {field: 'faceToFaceDate', asc: true},

    initialize: function(models, options){
        BaseCollection.prototype.initialize.apply(this, arguments);
    },

    comparator: function(a, b) {
        if (this.sortConf.field == "faceToFaceDate") {
            a = new Number(a.get("data")[this.sortConf.field]);
            b = new Number(b.get("data")[this.sortConf.field]);
        } else if (this.sortConf.field == "signedTime" || this.sortConf.field == "signed") {
            a = new Number(a.get("signedTime"));
            b = new Number(b.get("signedTime"));
        } else {
            a = (a.get(this.sortConf.field) || {}).name || "";
            b = (b.get(this.sortConf.field) || {}).name || "";
        }
        result = a > b ?  1
            : a < b ? -1
                :          0;

        if (!this.sortConf.asc){
            return result * -1;
        }
        return result;
    },

    sortByFieldAndDirection: function (fieldName, direction) {
        this.sortConf = {field: fieldName, asc: direction == "ASC"};
        this.sort();
    }
});


module.exports = FaceToFaceFormCollection;


//////////////////
// WEBPACK FOOTER
// ./app/collections/face-to-face-form-collection.js
// module id = 524
// module chunks = 0